import { AppState } from '@/store/state';
import { ToggleControlSidebar, ToggleSidebarMenu } from '@/store/ui/actions';
import { UiState } from '@/store/ui/state';
import { Component, HostBinding, HostListener, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Store } from '@ngrx/store';
import { ApiService } from '@services/api.service';
import { AppService } from '@services/app.service';
import { Observable, Subscription, interval } from 'rxjs';
import jwt_decode from 'jwt-decode';
import { login } from '@/Interface/Register';
import { UtilityService } from '@services/utility.service';
import { ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';

const BASE_CLASSES = '';

// Static mock data for testing
const MOCK_NOTIFICATION_DATA = {
    "pagination": {
        "total_records": 9,
        "total_pages": 1,
        "current_page": 1,
        "next_page": null,
        "previous_page": null
    },
    "results": [
        {
            "id": 11,
            "created_at": "2026-02-11T15:41:05.848470+05:00",
            "type": "details",
            "description": "Ticket updated",
            "ticket_id": 17,
            "ticket_title": "test12134",
            "is_read": false
        },
        {
            "id": 10,
            "created_at": "2026-02-11T15:02:45.087920+05:00",
            "type": "details",
            "description": "New ticket created",
            "ticket_id": 16,
            "ticket_title": "12312",
            "is_read": false
        },
        {
            "id": 9,
            "created_at": "2026-02-11T11:41:20.988280+05:00",
            "type": "details",
            "description": "New ticket created",
            "ticket_id": 15,
            "ticket_title": "Testinhh",
            "is_read": false
        },
        {
            "id": 6,
            "created_at": "2026-02-04T11:28:29.445526+05:00",
            "type": "details",
            "description": "Ticket updated",
            "ticket_id": 14,
            "ticket_title": "files test",
            "is_read": false
        },
        {
            "id": 5,
            "created_at": "2026-02-04T10:35:57.754829+05:00",
            "type": "details",
            "description": "New ticket created",
            "ticket_id": 13,
            "ticket_title": "final test",
            "is_read": false
        },
        {
            "id": 4,
            "created_at": "2026-02-04T10:08:55.367157+05:00",
            "type": "details",
            "description": "New ticket created",
            "ticket_id": 12,
            "ticket_title": "Test k",
            "is_read": false
        },
        {
            "id": 3,
            "created_at": "2026-02-04T09:43:23.765538+05:00",
            "type": "details",
            "description": "Ticket resolved",
            "ticket_id": 11,
            "ticket_title": "Testinggg",
            "is_read": false
        },
        {
            "id": 2,
            "created_at": "2026-02-03T16:55:59.090075+05:00",
            "type": "details",
            "description": "Ticket cancelled",
            "ticket_id": 10,
            "ticket_title": "testing",
            "is_read": false
        },
        {
            "id": 1,
            "created_at": "2026-01-20T16:57:06.706157+05:00",
            "type": "details",
            "description": "New ticket created",
            "ticket_id": 9,
            "ticket_title": "Ek tha tiger",
            "is_read": false
        }
    ]
};

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    // New topbar revamp — remove the second entry below to revert to the old header only.
    styleUrls: ['./header.component.scss', './header-revamp.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
    @ViewChild('msgDrop') msgDrop: NgbDropdown;
    @ViewChild('notifDrop') notifDrop: NgbDropdown;
    @ViewChild('userDrop') userDrop: NgbDropdown;

    @HostBinding('class') classes: string = BASE_CLASSES;
    public ui: Observable<UiState>;
    public searchForm: UntypedFormGroup;
    getauth: string = '';
    getDecodedTokan: string = '';
    authTokan: login;

    // Full lists (all data)
    public allNotifications = [];
    public allMessages = [];

    // Displayed lists (paginated)
    notificationList = [];
    messagesList = [];

    // Pagination
    notificationPageSize = 15;
    messagePageSize = 15;
    displayedNotificationCount = 15;
    displayedMessageCount = 15;

    // Counters
    unMarkedNotifications: number = 0;
    unMarkedMessages: number = 0;

    // Pagination info
    notificationPagination: any = null;
    messagePagination: any = null;

    public ticket_id: number;
    public user_id: number;
    public getList: any;

    // Topbar starts translucent (see header-revamp.scss); solidifies to
    // white once the page scrolls, so content behind it isn't distracting.
    isScrolled = false;

    @HostListener('window:scroll')
    onWindowScroll(): void {
        this.isScrolled = window.scrollY > 10;
    }

    // Breadcrumb trail, derived from each route's `data.title` (already set
    // on almost every route, originally just for the page <title>) instead
    // of being hardcoded per-page.
    breadcrumbs: string[] = [];
    private breadcrumbRouterSubscription: Subscription;
    private plantNameSubscription: Subscription;
    private selectedPlantName = '';

    // Polling
    private pollingSubscription: Subscription;
    private readonly POLLING_INTERVAL = 10000; // 10 seconds

    constructor(
        public appService: AppService,
        private store: Store<AppState>,
        private _apiService: ApiService,
        private _utiltiySevice: UtilityService,
        private router: Router
    ) { }

    ngOnInit() {
        this.showUserName();
        this.fetchNotifications();
        this.fetchNotificationMessages();
        document.addEventListener('visibilitychange', this.visibilityHandler);

        // Start polling only if tab is visible
        if (document.visibilityState === 'visible') {
            this.startPolling();
        }

        this.buildBreadcrumbs();
        this.breadcrumbRouterSubscription = this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe(() => this.buildBreadcrumbs());
        // The plant name lands after the detail page's API call resolves, so
        // the trail has to be rebuilt when it arrives — not just on navigation.
        this.plantNameSubscription = this._utiltiySevice.selectedPlantName$
            .subscribe((name: string) => {
                this.selectedPlantName = name;
                this.buildBreadcrumbs();
            });
    }

    ngOnDestroy() {
        this.stopPolling();
        document.removeEventListener('visibilitychange', this.visibilityHandler);
        this.breadcrumbRouterSubscription?.unsubscribe();
        this.plantNameSubscription?.unsubscribe();
    }

    // Walks the active route tree from the root, collecting each level's
    // `data.title` in order (e.g. ['Analysis & Reports', 'Inverter
    // Comparison']) — using the router's own current snapshot rather than
    // this component's own injected ActivatedRoute, since HeaderComponent
    // lives outside <router-outlet> and wouldn't otherwise see route
    // changes.
    private buildBreadcrumbs(): void {
        const crumbs: string[] = [];
        let hideBreadcrumb = false;
        let route: ActivatedRouteSnapshot | null = this.router.routerState.snapshot.root;
        while (route) {
            if (route.data?.['hideBreadcrumb']) {
                hideBreadcrumb = true;
            }
            // A drill-down page can sit beside its list page in the route
            // tree rather than under it (plant-detail is a sibling of
            // plants), so its route names the steps the tree doesn't show.
            const parents: string[] = route.data?.['parentCrumbs'] ?? [];
            crumbs.push(...parents);
            const title = route.data?.['title'];
            if (title) {
                crumbs.push(this.resolveCrumbTitle(route, title));
            }
            route = route.firstChild;
        }
        // Escape hatch for a page that renders its own breadcrumb inline:
        // data.hideBreadcrumb on its route stops the header from also
        // showing a duplicate. No route currently sets it.
        this.breadcrumbs = hideBreadcrumb ? [] : crumbs;
    }

    // A route can point at a live value to show in place of its static title:
    // the plant detail page reads better ending in the plant's own name than
    // in "Plant Details". Falls back to the title until the value arrives.
    private resolveCrumbTitle(route: ActivatedRouteSnapshot, title: string): string {
        if (route.data?.['titleFrom'] === 'selectedPlantName') {
            return this.selectedPlantName || title;
        }
        return title;
    }

    // Start polling every 10 seconds
    // startPolling(): void {
    //     this.pollingSubscription = interval(this.POLLING_INTERVAL).subscribe(() => {
    //         this.fetchNotifications(true); // true = silent update
    //         this.fetchNotificationMessages(true);
    //     });
    // }
    startPolling(): void {
    if (this.pollingSubscription) return; // prevent duplicate polling

    this.pollingSubscription = interval(this.POLLING_INTERVAL)
        .subscribe(() => {
            this.fetchNotifications(true);
            this.fetchNotificationMessages(true);
        });
}

    // Stop polling
    // stopPolling(): void {
    //     if (this.pollingSubscription) {
    //         this.pollingSubscription.unsubscribe();
    //     }
    // }
    stopPolling(): void {
    if (this.pollingSubscription) {
        this.pollingSubscription.unsubscribe();
        this.pollingSubscription = undefined as any;
    }
}

    // TrackBy function to prevent re-rendering
    trackByNotificationId(index: number, item: any): number {
        return item.id;
    }

    trackByMessageId(index: number, item: any): number {
        return item.id;
    }

    markAsRead(): void {
        if (!this.notificationList.filter(item => !item.is_read).length) {
            console.log('No unMarked notification Found!');
            return;
        }

        this.markAllAsRead();
    }

    markMessagesAsRead(): void {
        if (!this.messagesList.filter(item => !item.is_read).length) {
            console.log('No unMarked messages Found!');
            return;
        }

        this._utiltiySevice.markAllNotificationsRead({ type: 'communication' })
            .subscribe({
                next: () => {
                    this.allMessages.forEach(item => item.is_read = true);
                    this.messagesList.forEach(item => item.is_read = true);
                    this.unMarkedMessages = 0;
                },
                error: (err) => {
                    console.error('Failed to mark all messages as read', err);
                }
            });
    }

    fetchNotifications(silent: boolean = false): void {
        this._utiltiySevice.getNotifications('details')
            .subscribe({
                next: (response: any) => {
                    // Use mock data if response is empty or invalid
                    // if (!response || !response.results || response.results.length === 0) {
                    //     console.log('Using mock notification data');
                    //     response = MOCK_NOTIFICATION_DATA;
                    // }

                    if (response && response.results && response.results.length) {
                        this.notificationPagination = response.pagination;

                        // Map and format the data
                        const formattedData = response.results.map((notification: any) => ({
                            id: notification.id,
                            ticket_id: notification.ticket_id,
                            ticket_title: notification.ticket_title,
                            fsr_id: notification.fsr_id,
                            title: notification.title,
                            description: notification.description,
                            type: notification.type,
                            is_read: notification.is_read,
                            created_at: this.formatDateTime(notification.created_at)
                        }));

                        // Smart update: only update if there are new items
                        if (silent) {
                            this.updateNotificationsSmartly(formattedData);
                        } else {
                            this.allNotifications = formattedData;
                            this.updateDisplayedNotifications();
                        }

                        this.unMarkedNotifications = this.allNotifications.filter(item => !item.is_read).length;
                    }
                },
                error: (err) => {
                    console.error('Failed to load notifications, using mock data', err);
                    // Fallback to mock data on error
                    // const formattedData = MOCK_NOTIFICATION_DATA.results.map((notification: any) => ({
                    //     id: notification.id,
                    //     ticket_id: notification.ticket_id,
                    //     ticket_title: notification.ticket_title,
                    //     description: notification.description,
                    //     type: notification.type,
                    //     is_read: notification.is_read,
                    //     created_at: this.formatDateTime(notification.created_at)
                    // }));

                    this.allNotifications = [];
                    this.updateDisplayedNotifications();
                    this.unMarkedNotifications = this.allNotifications.filter(item => !item.is_read).length;
                }
            });
    }

    fetchNotificationMessages(silent: boolean = false): void {
        this._utiltiySevice.getNotifications('communication')
            .subscribe({
                next: (response: any) => {
                    // Use mock data if response is empty or invalid
                    // if (!response || !response.results || response.results.length === 0) {
                    //     console.log('Using mock message data');
                    //     response = {
                    //         ...MOCK_NOTIFICATION_DATA,
                    //         results: MOCK_NOTIFICATION_DATA.results.map(item => ({
                    //             ...item,
                    //             type: 'communication'
                    //         }))
                    //     };
                    // }

                    if (response && response.results && response.results.length) {
                        this.messagePagination = response.pagination;

                        const formattedData = response.results.map((notification: any) => ({
                            id: notification.id,
                            ticket_id: notification.ticket_id,
                            ticket_title: notification.ticket_title,
                            description: notification.description,
                            type: notification.type,
                            is_read: notification.is_read,
                            created_at: this.formatDateTime(notification.created_at)
                        }));

                        // Smart update: only update if there are new items
                        if (silent) {
                            this.updateMessagesSmartly(formattedData);
                        } else {
                            this.allMessages = formattedData;
                            this.updateDisplayedMessages();
                        }

                        this.unMarkedMessages = this.allMessages.filter(item => !item.is_read).length;
                    }
                },
                error: (err) => {
                    console.error('Failed to load messages, using mock data', err);
                    // Fallback to mock data on error
                    // const formattedData = MOCK_NOTIFICATION_DATA.results.map((notification: any) => ({
                    //     id: notification.id,
                    //     ticket_id: notification.ticket_id,
                    //     ticket_title: notification.ticket_title,
                    //     description: notification.description,
                    //     type: 'communication',
                    //     is_read: notification.is_read,
                    //     created_at: this.formatDateTime(notification.created_at)
                    // }));

                    this.allMessages = [];
                    this.updateDisplayedMessages();
                    this.unMarkedMessages = this.allMessages.filter(item => !item.is_read).length;
                }
            });
    }

    // Smart update - only add new notifications, don't re-render existing ones
    updateNotificationsSmartly(newData: any[]): void {
        const existingIds = new Set(this.allNotifications.map(n => n.id));
        const newItems = newData.filter(item => !existingIds.has(item.id));

        if (newItems.length > 0) {
            // Add new items to the beginning
            this.allNotifications = [...newItems, ...this.allNotifications];
            this.updateDisplayedNotifications();
        }

        // Update is_read status for existing items
        this.allNotifications.forEach(notification => {
            const updated = newData.find(n => n.id === notification.id);
            if (updated) {
                notification.is_read = updated.is_read;
            }
        });
    }

    updateMessagesSmartly(newData: any[]): void {
        const existingIds = new Set(this.allMessages.map(m => m.id));
        const newItems = newData.filter(item => !existingIds.has(item.id));

        if (newItems.length > 0) {
            // Add new items to the beginning
            this.allMessages = [...newItems, ...this.allMessages];
            this.updateDisplayedMessages();
        }

        // Update is_read status for existing items
        this.allMessages.forEach(message => {
            const updated = newData.find(m => m.id === message.id);
            if (updated) {
                message.is_read = updated.is_read;
            }
        });
    }

    // Update displayed notifications (first 15 or more if load more clicked)
    updateDisplayedNotifications(): void {
        this.notificationList = this.allNotifications.slice(0, this.displayedNotificationCount);
    }

    updateDisplayedMessages(): void {
        this.messagesList = this.allMessages.slice(0, this.displayedMessageCount);
    }

    // Check if there are more items to load
    hasMoreNotifications(): boolean {
        return this.notificationList.length < this.allNotifications.length ||
            (this.notificationPagination && this.notificationPagination.next_page !== null);
    }

    hasMoreMessages(): boolean {
        return this.messagesList.length < this.allMessages.length ||
            (this.messagePagination && this.messagePagination.next_page !== null);
    }

    // Load more functions
    loadMoreNotifications(): void {
        if (this.notificationList.length < this.allNotifications.length) {
            this.displayedNotificationCount += this.notificationPageSize;
            this.updateDisplayedNotifications();
        } else if (this.notificationPagination?.next_page) {
            this._utiltiySevice.getNotifications('details', this.notificationPagination.next_page)
                .subscribe({
                    next: (response: any) => {
                        if (response?.results?.length) {
                            this.notificationPagination = response.pagination;
                            const formatted = response.results.map((n: any) => ({
                                id: n.id,
                                ticket_id: n.ticket_id,
                                ticket_title: n.ticket_title,
                                fsr_id: n.fsr_id,
                                title: n.title,
                                description: n.description,
                                type: n.type,
                                is_read: n.is_read,
                                created_at: this.formatDateTime(n.created_at)
                            }));
                            this.allNotifications = [...this.allNotifications, ...formatted];
                            this.displayedNotificationCount += this.notificationPageSize;
                            this.updateDisplayedNotifications();
                        }
                    },
                    error: (err) => console.error('Failed to load more notifications', err)
                });
        }
    }

    loadMoreMessages(): void {
        if (this.messagesList.length < this.allMessages.length) {
            this.displayedMessageCount += this.messagePageSize;
            this.updateDisplayedMessages();
        } else if (this.messagePagination?.next_page) {
            this._utiltiySevice.getNotifications('communication', this.messagePagination.next_page)
                .subscribe({
                    next: (response: any) => {
                        if (response?.results?.length) {
                            this.messagePagination = response.pagination;
                            const formatted = response.results.map((n: any) => ({
                                id: n.id,
                                ticket_id: n.ticket_id,
                                ticket_title: n.ticket_title,
                                description: n.description,
                                type: n.type,
                                is_read: n.is_read,
                                created_at: this.formatDateTime(n.created_at)
                            }));
                            this.allMessages = [...this.allMessages, ...formatted];
                            this.displayedMessageCount += this.messagePageSize;
                            this.updateDisplayedMessages();
                        }
                    },
                    error: (err) => console.error('Failed to load more messages', err)
                });
        }
    }

    markAllAsRead(): void {
        if (!this.notificationList.some(item => !item.is_read)) {
            console.log('No unread notifications found!');
            return;
        }

        this._utiltiySevice.markAllNotificationsRead({ type: 'details' })
            .subscribe({
                next: () => {
                    this.allNotifications.forEach(item => item.is_read = true);
                    this.notificationList.forEach(item => item.is_read = true);
                    this.unMarkedNotifications = 0;
                },
                error: (err) => {
                    console.error('Failed to mark all as read', err);
                }
            });
    }

    clearNotification(id: number): void {
        this._utiltiySevice.clearNotification(id)
            .subscribe({
                next: () => {
                    this.allNotifications = this.allNotifications.filter(n => n.id !== id);
                    this.notificationList = this.notificationList.filter(n => n.id !== id);
                    this.unMarkedNotifications = this.allNotifications.filter(item => !item.is_read).length;
                },
                error: (err) => {
                    console.error('Failed to clear notification', err);
                }
            });
    }

    clearMessage(id: number): void {
        this._utiltiySevice.clearNotification(id)
            .subscribe({
                next: () => {
                    this.allMessages = this.allMessages.filter(n => n.id !== id);
                    this.messagesList = this.messagesList.filter(n => n.id !== id);
                    this.unMarkedMessages = this.allMessages.filter(item => !item.is_read).length;
                },
                error: (err) => {
                    console.error('Failed to clear message', err);
                }
            });
    }

    clearAllNotifications(): void {
        this._utiltiySevice.clearAllNotifications({ type: 'details' })
            .subscribe({
                next: () => {
                    this.allNotifications = [];
                    this.notificationList = [];
                    this.unMarkedNotifications = 0;
                },
                error: (err) => {
                    console.error('Failed to clear all notifications', err);
                }
            });
    }

    clearAllMessages(): void {
        this._utiltiySevice.clearAllNotifications({ type: 'communication' })
            .subscribe({
                next: () => {
                    this.allMessages = [];
                    this.messagesList = [];
                    this.unMarkedMessages = 0;
                },
                error: (err) => {
                    console.error('Failed to clear all messages', err);
                }
            });
    }

    onNotificationClick(event: Event, notification: any): void {
        this.closeDropdowns();
        if (!notification.is_read) {
            this._utiltiySevice.markNotificationRead(notification.id).subscribe({
                next: () => {
                    notification.is_read = true;
                    this.unMarkedNotifications = this.allNotifications.filter(n => !n.is_read).length;
                },
                error: () => { }
            });
        }
        // A "details" notification is about exactly one of a ticket or an
        // FSR — the backend only ever sets one of the two ids.
        if (notification.fsr_id) {
            this.navigateToFsr(notification.fsr_id);
        } else {
            this.navigateToTicket(notification.ticket_id);
        }
    }

    onMessageClick(event: Event, message: any): void {
        this.closeDropdowns();
        if (!message.is_read) {
            this._utiltiySevice.markNotificationRead(message.id).subscribe({
                next: () => {
                    message.is_read = true;
                    this.unMarkedMessages = this.allMessages.filter(m => !m.is_read).length;
                },
                error: () => { }
            });
        }
        this.navigateToTicket(message.ticket_id);
    }

    // closeDropdowns(): void {
    // document.querySelectorAll('.dropdown-toggle.show, [data-bs-toggle="dropdown"]').forEach(el => {
    //     const bsDropdown = (window as any).bootstrap?.Dropdown?.getInstance(el);
    //     if (bsDropdown) {
    //         bsDropdown.hide();
    //     }
    // });
    // }
    // closeDropdowns(): void {
    // document.querySelectorAll('.dropdown-menu.show').forEach(el => {
    //     el.classList.remove('show');
    // });
    // document.querySelectorAll('.dropdown-toggle[aria-expanded="true"]').forEach(el => {
    //     el.setAttribute('aria-expanded', 'false');
    //     el.classList.remove('show');
    // });}
    closeDropdowns(): void {
        console.log('dropdown clicked')
        setTimeout(() => {
            this.msgDrop?.close();
            this.notifDrop?.close();
            this.userDrop?.close();
        }, 0);
    }

    // Navigate to ticket detail page
    navigateToTicket(ticketId: number): void {
        if (ticketId) {
            this.router.navigate(['/help-desk/tickets', ticketId]);
        }
    }

    // Navigate to FSR detail page
    navigateToFsr(fsrId: number): void {
        if (fsrId) {
            this.router.navigate(['/help-desk/fsr', fsrId]);
        }
    }

    formatDateTime(dateTimeString: string): string {
        const date = new Date(dateTimeString);
        const options: Intl.DateTimeFormatOptions = {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        };

        const formatted = date.toLocaleString('en-GB', options);
        return formatted.replace(',', ' |');
    }

    profilePic() {
        return this.appService.profileImage$;
    }

    logout() {
        this.appService.logout();
    }

    onToggleMenuSidebar() {
        this.store.dispatch(new ToggleSidebarMenu());
    }

    onToggleControlSidebar() {
        this.store.dispatch(new ToggleControlSidebar());
    }

    showUserName() {
        this.getDecodedTokan = localStorage.getItem('tokan');
        this.authTokan = jwt_decode(this.getDecodedTokan);
    }
    private visibilityHandler = () => {
        if (document.visibilityState === 'visible') {
            this.startPolling();
        } else {
            this.stopPolling();
        }
    };
}